import Swiper, {EffectFade, HashNavigation} from 'swiper';

const investOptions = document.querySelectorAll('.invest-option');

if (investOptions.length > 0) {
    investOptions.forEach((investOption) => {
        const investMethods = Array.from(investOption.querySelectorAll('.j-invest__method'));
        const investSlider = investOption.querySelector('.j-invest__slider');

        let swiper = {};

        if (investSlider) {
            const tenderOptions = {
                modules          : [EffectFade, HashNavigation],
                autoHeight       : true,
                init             : false,
                loop             : false,
                speed            : 1000,
                spaceBetween     : 0,
                slidesPerView    : 1,
                slidesOffsetAfter: 0,
                allowTouchMove   : false,
                effect           : 'fade',
                fadeEffect       : {
                    crossFade: true
                }
            };

            swiper = new Swiper(investSlider, tenderOptions).init();
        }

        investMethods.forEach((button) => {
            button.addEventListener('click', () => {
                if (button.classList.contains('is-active')) {
                    return;
                }

                const nowActive = investMethods.find((item) => {
                    return item.classList.contains('is-active');
                });

                if (swiper.initialized) {
                    swiper.slideTo(button.dataset.slide - 1);
                }

                if (nowActive) {
                    nowActive.classList.remove('is-active');
                }

                button.classList.add('is-active');
            });
        });

        window.addEventListener('resize', () => {
            swiper.updateAutoHeight(300);
        });
    });
}
